import { COLORS } from "../../ui/Theme";
import { Box, Typography } from "@mui/material";
import { IoMdCheckmark } from "react-icons/io";


const features = ["تابلوخوانی", "ابزارهای مشتقه", "بورس کالای داخلی", "بازارهای جهانی", "مقایسه بازدهی"]

const SubscriptionCardFeatures = () => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "10px",
            width: "100%",
        }}>
            {
                features.map((item, index) => (
                    <Box key={index} sx={{ display: "flex", gap: 2 }}>
                        <IoMdCheckmark color={COLORS.BLUE} />
                        <Typography sx={{ fontSize: "16px" }}>{item}</Typography>
                    </Box>
                ))
            }
        </Box>
    );
};

export default SubscriptionCardFeatures;